// extracted by mini-css-extract-plugin
module.exports = {"avatarWrapper":"uploadAvatar_avatarWrapper__1KeI_","avatar":"uploadAvatar_avatar__2Fl5j","badge":"uploadAvatar_badge__JLBzQ"};